module.exports = __webpack_public_path__ + "static/media/disputas.ce58cbd8.png";


//////////////////
// WEBPACK FOOTER
// ./src/Img/disputas.png
// module id = 284
// module chunks = 0